<template>
  <button :class="{ btn: true, grey: disabled }" :disabled="disabled">
    {{ text }} <span :class="{ fa: true, 'fa-chevron-down': !active, 'fa-chevron-up': active }"></span>
  </button>
</template>

<script>
export default {
  name: 'DropdownToggler',
  props: {
    text: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['sharedState'],
  computed: {
    active() {
      return this.sharedState.active;
    },
  },
};
</script>

<style>
</style>
